<layout>
  <top-bar>
    <sub-navigation>
      <sub-navigation-item path="/map">{{ 'TAB.MAP' | translate }}</sub-navigation-item>
    </sub-navigation>
  </top-bar>
  <left-panel [isExpanded]="false" swipePosition="opened">
    <container [padding]="'small'">
      <div style="display: flex; gap: 0.5rem">
        <form [formGroup]="formGroup" style="flex: 1">
          <searchbar formControlName="searchValue" [placeholder]="'DEVICE.SEARCHDEVICE' | translate" />
        </form>
        <button
          aria-hidden="false"
          [matBadge]="filtersCount === 0 ? null : filtersCount"
          matMiniFab
          [class]="$displayFilters() ? 'filter-toggle-active' : 'filter-toggle'"
          (click)="toggleFilters()">
          <mat-icon>filter_alt</mat-icon>
        </button>
      </div>
      <!-- FILTERS -->
      <device-filter [filtersFormGroup]="filtersFormGroup" [$displayFilters]="$displayFilters" />
    </container>
    <container verticalHeight="fill" [padding]="'none'">
      @if ($visibleResult(); as visibleResult) {
        @if (visibleResult.length) {
          <cdk-virtual-scroll-viewport [itemSize]="deviceCardHeight" class="map-tab__device-list">
            <device-card-2
              *cdkVirtualFor="let item of visibleResult; trackBy: trackById"
              [uid]="item.id"
              class="map-tab__device-card device-card--single-line"
              [style.height.px]="deviceCardHeight"
              (click)="goToHistory(item.id)" />
          </cdk-virtual-scroll-viewport>
        } @else {
          <alert genre="muted" variant="info" style="padding: 0.5rem">
            {{ (search?.length ? 'MAP.NO_MATCH' : 'MAP.NO_RESULT_FOUND') | translate }}
          </alert>
        }
      } @else {
        <alert genre="muted" variant="info" style="padding: 0.5rem">
          {{ 'MAP.PLEASE_ZOOM' | translate }}
        </alert>
      }
    </container>
  </left-panel>
</layout>
